export default {
	height: 60
};